import moment from "moment";
import { APPROVE } from "src/common/constants";
import { ApprovalActionI } from "../reducers/approve";
export const APPROVE_FETCH = `${APPROVE}_GET` as const;
export const APPROVE_FETCH_INVOKED = `${APPROVE}_GET_INVOKED` as const;
export const APPROVE_FETCH_SUCCESS = `${APPROVE}_GET_SUCCESS` as const;
export const APPROVE_FETCH_FAILED = `${APPROVE}_GET_FAILED` as const;
export const APPROVE_FETCH_ONE = `${APPROVE}_GET_ONE` as const;
export const APPROVE_FETCH_ONES = `${APPROVE}_GET_ONES` as const;
export const APPROVE_FETCH_ONE_SUCCESS = `${APPROVE}_GET_ONE_SUCCESS` as const;
export const APPROVE_FETCH_ONE_FAILED = `${APPROVE}_GET_ONE_FAILED` as const;
export const APPROVE_DATA_SORT_SAGA = `${APPROVE}_DATA_SORT_SAGA` as const;
export const APPROVE_DATA_SORT = `${APPROVE}_DATA_SORT` as const;
export const APPROVE_SET_QUERY_SAGA = `${APPROVE}_SET_QUERY_SAGA` as const;
export const APPROVE_SET_QUERY = `${APPROVE}_SET_QUERY` as const;
export const APPROVE_SET_DATES_SAGA = `${APPROVE}_SET_DATES_SAGA` as const;
export const APPROVE_SET_DATES = `${APPROVE}_SET_DATES` as const;
export const APPROVE_SET_PAGE_SAGA = `${APPROVE}_SET_PAGE_SAGA` as const;
export const APPROVE_SET_PAGE = `${APPROVE}_SET_PAGE` as const;
export const APPROVE_SET_TAB_SAGA = `${APPROVE}_SET_TAB_SAGA` as const;
export const APPROVE_SET_TAB = `${APPROVE}_SET_TAB` as const;
export const APPROVE_SET_APP_STATUSES = `${APPROVE}_SET_APP_STATUSES` as const;
export const APPROVE_SET_APP_STATUSES_SAGA =
  `${APPROVE}_SET_APP_STATUSES_SAGA` as const;
export const APPROVE_SET_BOOKING_STATUSES =
  `${APPROVE}_SET_BOOKING_STATUSES` as const;
export const APPROVE_SET_BOOKING_STATUSES_SAGA =
  `${APPROVE}_SET_BOOKING_STATUSES_SAGA` as const;

export interface SetApproveQueryI {
  query: string;
  id: string;
}

export interface SetApproveQueryActionI extends SetApproveQueryI {
  type: typeof APPROVE_SET_QUERY;
}

export const setApproveQuery = ({
  query,
  id,
}: SetApproveQueryI): ApprovalActionI => {
  return {
    type: APPROVE_SET_QUERY,
    query,
    id,
  };
};

export interface SetApproveDatesI {
  startDate: moment.Moment;
  endDate: moment.Moment;
  id: string;
}

export interface SetApproveDatesActionI extends SetApproveDatesI {
  type: typeof APPROVE_SET_DATES;
}

export const setApproveDates = ({
  startDate,
  endDate,
  id,
}: SetApproveDatesI): ApprovalActionI => {
  return {
    type: APPROVE_SET_DATES,
    startDate,
    endDate,
    id,
  };
};

export interface SetApprovePageI {
  page: number;
  id: string;
}

export interface SetApprovePageActionI extends SetApprovePageI {
  type: typeof APPROVE_SET_PAGE;
}

export const setApprovePage = ({
  page,
  id,
}: SetApprovePageI): ApprovalActionI => {
  return {
    type: APPROVE_SET_PAGE,
    page,
    id,
  };
};

export interface SetApproveTabI {
  selectedTab: string;
  id: string;
}

export interface SetApproveTabActionI extends SetApproveTabI {
  type: typeof APPROVE_SET_TAB;
}

export const setApproveTab = ({
  selectedTab,
  id,
}: SetApproveTabI): ApprovalActionI => {
  return {
    type: APPROVE_SET_TAB,
    selectedTab,
    id,
  };
};

export interface SetApprovalStatusesI {
  approvalStatuses: number[];
  id: string;
}

export interface SetApprovalStatusesActionI extends SetApprovalStatusesI {
  type: typeof APPROVE_SET_APP_STATUSES;
}

export const setApprovalStatuses = ({
  approvalStatuses,
  id,
}: SetApprovalStatusesI): ApprovalActionI => {
  return {
    type: APPROVE_SET_APP_STATUSES,
    approvalStatuses,
    id,
  };
};

export interface SetBookingStatusesI {
  bookingStatuses: number[];
  id: string;
}

export interface SetBookingStatusesActionI extends SetBookingStatusesI {
  type: typeof APPROVE_SET_BOOKING_STATUSES;
}

export const setBookingStatuses = ({
  bookingStatuses,
  id,
}: SetBookingStatusesI): ApprovalActionI => {
  return {
    type: APPROVE_SET_BOOKING_STATUSES,
    bookingStatuses,
    id,
  };
};

export interface SortApproveDataI {
  sortColumn: string;
  sortDirection: "ascending" | "descending";
}

export interface ApproveDataSortActionI extends SortApproveDataI {
  type: typeof APPROVE_DATA_SORT;
  id: string;
}

export const sortApproveData = (
  data: SortApproveDataI,
  id: string
): ApprovalActionI => {
  return {
    type: APPROVE_DATA_SORT,
    id,
    ...data,
  };
};
